import { Component, Input } from '@angular/core';
import { IFaqOrdered } from 'src/models/faq.model';
import { CollaboratorRoute, FaqRoute } from 'src/models/routes.model';

@Component({
  selector: 'liberro-help-section',
  standalone: false,
  templateUrl: './liberro-help-section.component.html',
  styleUrl: './liberro-help-section.component.less'
})
export class LiberroHelpSectionComponent {
  @Input({ required: true }) public faqList!: IFaqOrdered[];
  @Input() public displayInColumn = false;
  @Input() public desktopButtonWidths?: string;
  @Input() public variant: 'default' | 'compact' = 'default';

  public faqOverviewUrl =`/${FaqRoute.FAQ}`;
  public collaboratorRoute =`/${CollaboratorRoute.COLLABORATOR}`;
}
